
















import { ciList } from '~/icons/source/solid/list'
import {
  defineComponent,
  ref,
  toRefs,
  defineVue3AsyncComponent
} from '~/utils/nuxt3-migration'
import { useAnalytics } from '~/compositions/analytics'

export default defineComponent({
  components: {
    CClassifiedListModal: defineVue3AsyncComponent(() =>
      import(
        '~/components/shared/configurable/classified/list/CClassifiedListModal.vue'
      )
    )
  },
  props: {
    classified: { type: Object, required: true },
    round: { type: Boolean, required: false },
    isModal: { type: Boolean, default: false }
  },
  setup(props) {
    const { classified } = toRefs(props)
    const analytics = useAnalytics()

    const listsModalVisible = ref(false)

    function handleShowList() {
      listsModalVisible.value = true
      analytics.recordEvent({
        namespace: 'n_lists_button_clicked_in_classified',
        action: 'click',
        label: classified.value.title + ' (' + classified.value.id + ')'
      })
    }

    return { listsModalVisible, ciList, handleShowList }
  }
})
